import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ListIcon, RowsIcon } from '@phosphor-icons/react'

import { parcelPresentationTypes } from './constants'

const useParcelsPresentationType = () => {
  const { t } = useTranslation()
  const [parcelPresentationType, setParcelPresentationType] = useState(
    localStorage.getItem('parcelPresentationType') || parcelPresentationTypes.rows
  )

  const onChangePresentationType = presentationType => {
    setParcelPresentationType(presentationType)
    localStorage.setItem('parcelPresentationType', presentationType)
  }

  const parcelPresentationOptions = [
    {
      id: parcelPresentationTypes.rows,
      Icon: RowsIcon,
      label: t('Tarjetas'),
      onClick: () => onChangePresentationType(parcelPresentationTypes.rows),
    },
    {
      id: parcelPresentationTypes.list,
      Icon: ListIcon,
      iconWeightOnActive: 'bold',
      label: t('Lista'),
      onClick: () => onChangePresentationType(parcelPresentationTypes.list),
    },
  ]

  return {
    parcelPresentationType,
    parcelPresentationOptions,
    onChangePresentationType,
  }
}

export default useParcelsPresentationType
